module.exports = __webpack_public_path__ + "un-tenanted-deployment-logo.9b2a0a56923f52a97d9b4f65bab25c14.hashedasset.svg";